import React, { Component } from "react";
import classes from "./addNewUser.module.css";
import Button from "@material-ui/core/Button";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import axios from "../../../../axios-order";
import Appbar from "../../../../components/appBar/appBar";
import BoxWrapper from "../../../../components/ui/boxWrapper";
import Checkbox from "@mui/material/Checkbox";
import { toast } from "react-toastify";

const useStyles = makeStyles({
  list: {
    width: 1050,
    height: 1000,
  },
  fullList: {
    width: "auto",
  },
});

class addNewUser extends Component {
  constructor(props) {
    super(props);
    this.state = {
      newEntityUsers: [],
      business_entity_id: this.props.location.state.business_entity_id,
      user_id: localStorage.getItem("user_id"),
      privileges: [],
      custom_privileges: {
        selected: "",
        views: [],
      },
      loading: false,
      checked_privileges: {},
      users: this.props.location.state.users,
      is_edit: this.props.location.state.is_edit || false,
      is_create_group: this.props.location.state.is_create_group || false,
      existing_services: this.props.location.state.existing_services || [],
      all_services: {},
      groupName: "",
      selectAllFull: false,
      selectAllRead: false,
      selectAllWrite: false,
      PERMISSIONS: {
        READ: 1,
        WRITE: 2,
        FULL: 3,
      },
    };
  }

  componentDidMount = () => {
    this.getPrivileges().then(() => {
      if (this.state.is_edit && this.state.existing_services.length) {
        const checked_privileges = {};
        this.state.existing_services.forEach((service) => {
          checked_privileges[service.service_name] = this.state.PERMISSIONS[service.privilege];
        });
        this.setState({ checked_privileges });
      }
    });
    this.getGroupNames();
  };

  getPrivileges = async () => {
    const entityId = this.state.business_entity_id;
    const userId = this.state.users[0];
    const userid = this.state.user_id;

    try {
      this.setState({ loading: true });
      const res = await axios.get(`/service_list_by_entity/${userId}/${entityId}/${userid}`);
      this.setState({ privileges: res.data.services });
      let services = {};
      Object.keys(res.data.services).forEach((k) => {
        Object.keys(res.data.services[k]).forEach((pk) => {
          services = { ...services, ...res.data.services[k][pk] };
        });
      });
      this.setState((prevState) => ({
        all_services: { ...prevState.all_services, ...services },
      }));
    } catch (error) {
      toast.error("Unable to load Services. Please refresh and try again.");
    } finally {
      this.setState({ loading: false });
    }
  };

  getGroupNames = async () => {
    try {
      const res = await axios.get(`/get_group_names/${this.state.business_entity_id}/${this.state.user_id}`);
      if (res.data.status) {
        const views = res.data.groups.map((group) => ({
          label: group,
          value: group,
        }));
        this.setState((prevState) => ({
          custom_privileges: {
            ...prevState.custom_privileges,
            views,
          },
        }));
      }
    } catch (error) {
      toast.error("Unable to load group names. Please try again.");
    }
  };

  handleSelectAll = (box) => (event) => {
    const checked = event.target.checked;
    const bit = this.state.PERMISSIONS[box];

    this.setState((prevState) => {
      const updated = { ...prevState.checked_privileges };

      Object.keys(prevState.privileges).forEach((k) => {
        Object.keys(prevState.privileges[k]).forEach((pk) => {
          Object.keys(prevState.privileges[k][pk]).forEach((s) => {
            const current = updated[s] || 0;
            const newValue = checked ? current | bit : current & ~bit;
            if (newValue === 0) {
              delete updated[s];
            } else {
              updated[s] = newValue;
            }
          });
        });
      });

      const selectAllKey = `selectAll${box.charAt(0).toUpperCase() + box.slice(1).toLowerCase()}`;

      return {
        checked_privileges: updated,
        [selectAllKey]: checked,
      };
    });
  };

  updatePrivileges = async (event) => {
    const selectedGroup = event.target.value;

    this.setState((prevState) => ({
      custom_privileges: {
        ...prevState.custom_privileges,
        selected: selectedGroup,
      },
    }));

    if (!selectedGroup) return;

    try {
      const { data } = await axios.post(`/get_group_services`, {
        business_entity_id: parseInt(this.state.business_entity_id),
        group_name: selectedGroup,
        user_id: parseInt(this.state.user_id)
      });

      if (data.status) {
        const services = JSON.parse(data.services_data.replace(/'/g, '"'));
        const checked_privileges = {};
        services.forEach((service) => {
          checked_privileges[service.service_name] = this.state.PERMISSIONS[service.privilege];
        });
        this.setState({ checked_privileges });
      }
    } catch (error) {
      toast.error("Unable to load group services. Please try again.");
    }
  };

  updateCheckBox = (name, box) => (event) => {
    const checked = event.target.checked;
    const bit = this.state.PERMISSIONS[box];

    this.setState((prevState) => {
      const current = prevState.checked_privileges[name] || 0;
      const newValue = checked ? current | bit : current & ~bit;
      const updated = { ...prevState.checked_privileges };

      if (newValue === 0) {
        delete updated[name];
      } else {
        updated[name] = newValue;
      }

      return { checked_privileges: updated };
    });
  };

  // ── CHANGED: added thInner div class, removed inline styles ──
  headers = () => {
    return (
      <tr>
        <th>Services</th>
        <th>
          <div className={classes.thInner}>
            <span>Full</span>
            <Checkbox
              onChange={this.handleSelectAll("FULL")}
              checked={this.state.selectAllFull}
              size="small"
              title="Select All Full"
              sx={{ padding: "0px", color: "#1a3a5c", "&.Mui-checked": { color: "#1a3a5c" } }}
            />
          </div>
        </th>
        <th>
          <div className={classes.thInner}>
            <span>Read</span>
            <Checkbox
              onChange={this.handleSelectAll("READ")}
              checked={this.state.selectAllRead}
              size="small"
              title="Select All Read"
              sx={{ padding: "0px", color: "#1a3a5c", "&.Mui-checked": { color: "#1a3a5c" } }}
            />
          </div>
        </th>
        <th>
          <div className={classes.thInner}>
            <span>Write</span>
            <Checkbox
              onChange={this.handleSelectAll("WRITE")}
              checked={this.state.selectAllWrite}
              size="small"
              title="Select All Write"
              sx={{ padding: "0px", color: "#1a3a5c", "&.Mui-checked": { color: "#1a3a5c" } }}
            />
          </div>
        </th>
      </tr>
    );
  };

  handleAddPrivileges = async () => {
    const permissionMap = {
      1: "READ",
      2: "WRITE",
      3: "FULL",
    };

    const payload = Object.keys(this.state.checked_privileges).reduce(
      (acc, cur) => {
        acc.services_selected.push({
          service_name: cur,
          service_id: this.state.all_services[cur],
          privilege: permissionMap[this.state.checked_privileges[cur]],
        });
        return acc;
      },
      { services_selected: [] }
    );
    payload.business_entity_id = this.state.business_entity_id;
    payload.users = this.state.users;

    try {
      this.setState({ loading: true });
      const { data } = await axios.post(
        `/service_list_by_entity/${this.state.business_entity_id}`,
        payload
      );
      if (data.success) {
        toast.success("Users Added successfully");
        this.props.history.goBack();
      }
    } catch (error) {
      toast.error("Couldn't Add the users. Please try again");
    }
    this.setState({ loading: false });
  };

  backHandler = () => {
    this.props.history.goBack();
  };

  handleAssignServices = async () => {
    const permissionMap = { 1: "READ", 2: "WRITE", 3: "FULL" };

    const selectedKeys = Object.keys(this.state.checked_privileges);
    if (selectedKeys.length === 0) {
      toast.error("Please select at least one service");
      return;
    }

    const services_selected = selectedKeys.map((cur) => ({
      service_name: cur,
      service_id: this.state.all_services[cur],
      privilege: permissionMap[this.state.checked_privileges[cur]],
    }));

    const creditEvalIndex = services_selected.findIndex(
      (s) => s.service_name === "CREDIT EVALUATION"
    );

    if (creditEvalIndex !== -1) {
      services_selected[creditEvalIndex].service_id = 32;
      services_selected[creditEvalIndex].privilege = "WRITE";
    }

    try {
      this.setState({ loading: true });

      if (!this.state.is_create_group) {
        const payload = {
          services_selected,
          business_entity_id: parseInt(this.state.business_entity_id),
          users: this.state.users.map((u) => parseInt(u)),
        };

        const { data } = await axios.post(`/assign_services_to_user`, payload);

        if (!data.status) {
          toast.error("Couldn't assign services. Please try again");
          this.setState({ loading: false });
          return;
        }

        toast.success("Services assigned successfully");
      }

      if (this.state.groupName.trim()) {
        const payload = {
          group_name: this.state.groupName,
          business_entity_id: parseInt(this.state.business_entity_id),
          services_selected,
          user_id: this.state.user_id,
        };

        const { data } = await axios.post(`/create_service_group`, payload);

        if (!data.status) {
          toast.error("Couldn't create service group. Please try again");
          this.setState({ loading: false });
          return;
        }

        toast.success("Service group created successfully");
      }

      if (this.state.is_create_group && !this.state.groupName.trim()) {
        toast.error("Please enter a group name");
        this.setState({ loading: false });
        return;
      }

      this.props.history.goBack();
    } catch (error) {
      toast.error("Something went wrong. Please try again");
    }

    this.setState({ loading: false });
  };

  // ── CHANGED: replaced inline style={{ background: "grey/lightgrey" }} with className ──
  privileges = () => {
    if (this.state.loading) {
      return (
        <tr>
          <td colSpan={4}>Loading. Please wait...</td>
        </tr>
      );
    }

    const { privileges } = this.state;
    const keys = Object.keys(privileges);

    if (!keys.length) return null;

    return keys.map((k) => (
      <React.Fragment key={k}>
        <tr className={classes.sectionRow}>
          <td colSpan={4}>{k}</td>
        </tr>

        {Object.keys(privileges[k]).map((pk) => (
          <React.Fragment key={pk}>
            {pk !== "NA" && pk !== k && (
              <tr className={classes.subsectionRow}>
                <td colSpan={4}>{pk}</td>
              </tr>
            )}
            {Object.keys(privileges[k][pk]).map((s) => (
              <tr key={s}>
                <td>{s}</td>
                <td>
                  <Checkbox
                    onChange={this.updateCheckBox(s, "FULL")}
                    checked={this.state.checked_privileges[s] === 3}
                    size="small"
                    sx={{ color: "#1a3a5c", "&.Mui-checked": { color: "#1a3a5c" } }}
                  />
                </td>
                <td>
                  <Checkbox
                    onChange={this.updateCheckBox(s, "READ")}
                    checked={[1, 3].includes(this.state.checked_privileges[s])}
                    size="small"
                    sx={{ color: "#1a3a5c", "&.Mui-checked": { color: "#1a3a5c" } }}
                  />
                </td>
                <td>
                  <Checkbox
                    onChange={this.updateCheckBox(s, "WRITE")}
                    checked={[2, 3].includes(this.state.checked_privileges[s])}
                    size="small"
                    sx={{ color: "#1a3a5c", "&.Mui-checked": { color: "#1a3a5c" } }}
                  />
                </td>
              </tr>
            ))}
          </React.Fragment>
        ))}
      </React.Fragment>
    ));
  };

  render() {
    return (
      <>
        <Appbar />
        <div className={classes.addNewUserSection}>
          <button className="button-outlined-primary" onClick={this.backHandler}>
            Back
          </button>
          <BoxWrapper
            boxTitle="Add Privileges"
            headerBgColor="#1a3a5c"
            enableDropdown={true}
            dropdownOptions={this.state.custom_privileges.views}
            dropdownHandlerFn={this.updatePrivileges}
            dropdownValue={this.state.custom_privileges.selected}
            dropdownLabel="Custom Privilege"
            dropdownWidth="200px"
            enableTextInput={true}
            textInputPlaceholder="Enter Group Name"
            textInputOnchange={(e) => this.setState({ groupName: e.target.value })}
            textInputValue={this.state.groupName}
          >
            {/* ── CHANGED: table uses classes.tablecss instead of "custome-table" ── */}
            <div className={classes.responsive_table}>
              <table className={classes.tablecss}>
                <thead>{this.headers()}</thead>
                <tbody>{this.privileges()}</tbody>
              </table>
            </div>

            <div style={{ display: "flex", justifyContent: "flex-end", padding: "16px" }}>
              <button
                className="button-outlined-primary"
                onClick={this.handleAssignServices}
                disabled={this.state.loading}
              >
                {this.state.loading ? "Submitting..." : "Submit"}
              </button>
            </div>
          </BoxWrapper>
        </div>
      </>
    );
  }
}

export default withStyles(useStyles, { withTheme: true })(addNewUser);